module.exports = __webpack_public_path__ + "media/images/kitchen-7ab1ef99.webp";